<template>
  <div class="nav">
    <ul v-if="isAuthenticated">
      <li v-if="isUser">
        <router-link to="/">Home</router-link>
      </li>
      <li v-if="isUser">
        <router-link to="/tracker">Tracker</router-link>
      </li>
      <li v-if="isUser">
        <router-link to="/code">Code</router-link>
      </li>
      <li v-if="isUser">
        <router-link to="/ereader">eReader</router-link>
      </li>
      <li v-if="isAdmin">
        <router-link to="/admin">Admin</router-link>
      </li>
      <li>
        <router-link to="/schedule">Schedule</router-link>
      </li>
      <li class="logout-button">
        <a @click="logout">Log Out</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { signOut } from "firebase/auth";
import { auth } from "../firebaseConfig"; // Use the shared auth instance
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  name: "NavBar",
};
</script>

<script setup>
const store = useStore();
const router = useRouter();
const isAuthenticated = computed(() => store.getters.isAuthenticated);
const isUser = computed(
  () =>
    store.getters.getRole === "user" || store.getters.getRole === "admin"
);
const isAdmin = computed(() => store.getters.getRole === "admin");
const logout = async () => {
  try {
    await signOut(auth);
    // Optionally, redirect to the login page or perform other actions
    // after logout, like clearing the store:
    store.dispatch("setAuthenticated", false);
    store.dispatch("setUser", null);
    router.push({ name: "login" });
  } catch (error) {
    console.error("Error signing out:", error);
    // Handle the error, e.g., display an error message to the user
  }
};
</script>

<style scoped lang="scss">
.nav {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  z-index: 10;
}

.nav ul {
  list-style-type: none;
  padding: 10px 20px;
  margin: 0;
  display: flex;
  gap: 10px;
  background: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  flex-wrap: wrap;
  justify-content: center;
}

.nav a {
  text-decoration: none;
  color: $secondary-text-color;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.nav a:hover,
.nav a.router-link-active {
  color: $cyan;
  background: rgba(6, 182, 212, 0.1);
  box-shadow: 0 0 10px rgba(6, 182, 212, 0.2);
  cursor: pointer;
}

.logout-button a:hover {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
  box-shadow: 0 0 10px rgba(239, 68, 68, 0.2);
}
</style>
